import { ACTIVATION_SELECT_ENABLE } from "./ItemMyStatBase"


export class ReqParkList {
    constructor({ start, limit, park_name = "", park_activation = ACTIVATION_SELECT_ENABLE }) {
        this.start = start
        this.limit = limit
        this.park_name = park_name
        this.park_activation = park_activation
    }

    fromJson(jsonData) {
        this.start = jsonData.start || 0
        this.limit = jsonData.limit || 10
        this.park_name = jsonData.park_name || ""
        this.park_activation = jsonData.park_activation
    }

    get_park_activation() {
        return this.park_activation === 1 ? true : false
    }
}

export class ReqParkDetail {
    constructor({park_id}){
        this.park_id = park_id
    }
    fromJson(jsonData){
        this.park_id = jsonData.park_id
    }
}

export class RespPark {
    constructor({park_id, park_name, park_name_eng, park_activation, park_last_change, park_note, park_pic_profile, park_pic_profile_auth, park_pic_profile_date, park_plan, park_plan_auth, park_plan_date}){
        this.park_id = park_id 
        this.park_name = park_name 
        this.park_name_eng = park_name_eng 
        this.park_activation = park_activation 
        this.park_last_change = park_last_change 
        this.park_note = park_note
        this.park_pic_profile = park_pic_profile 
        this.park_pic_profile_auth = park_pic_profile_auth
        this.park_pic_profile_date = park_pic_profile_date
        this.park_plan = park_plan 
        this.park_plan_auth = park_plan_auth
        this.park_plan_date = park_plan_date
    }

    fromJson(jsonData){
        this.id = jsonData._id
        this.park_id = jsonData.park_id 
        this.park_name = jsonData.park_name 
        this.park_name_eng = jsonData.park_name_eng 
        this.park_activation = jsonData.park_activation
        this.park_last_change = jsonData.park_last_change 
        this.park_note = jsonData.park_note
        this.park_pic_profile = jsonData.park_pic_profile 
        this.park_pic_profile_auth = jsonData.park_pic_profile_auth
        this.park_pic_profile_date = jsonData.park_pic_profile_date
        this.park_plan = jsonData.park_plan 
        this.park_plan_auth = jsonData.park_plan_auth
        this.park_plan_date = jsonData.park_plan_date
    }
}